import { render, staticRenderFns } from "./formula.vue?vue&type=template&id=5c405056&scoped=true&"
import script from "./formula.vue?vue&type=script&lang=js&"
export * from "./formula.vue?vue&type=script&lang=js&"
import style0 from "./formula.vue?vue&type=style&index=0&id=5c405056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c405056",
  null
  
)

export default component.exports